import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import {
  ApiGet,
  ApiPut,
  ApiDelete,
  ApiPost,
} from "../../../helpers/API/ApiData";
import axios from "axios";
import { customStyles } from "../tableStyle";
import { TailSpin } from "react-loader-spinner";
import "./vattenfall.scss";
import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { Trash } from "react-feather";
import { Button } from "reactstrap";
import Select from "react-select";
import DateFilter from "../Stepper/DateFilter";
import moment from "moment";
import "moment-timezone";
import { Modal } from "react-bootstrap";
import AddLeadDetails from "../Stepper/addNewLead/AddLeadDetails";
import { getUserInfo } from "../../../utils/user.util";
import excelIcon from "../../../assets/icon/xcelIco.png";
import * as XLSX from "xlsx";
import ValidateForm from "./LeadsValidations";

export default function VattenfallLeads() {
  const [getNewsData, setGetNewsData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [countForModel, setCountForModel] = useState(0);
  const [close, setclose] = useState("");
  const [image, setimage] = useState("");
  const [fileType, setfileType] = useState("");
  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);
  const [userName, setUserName] = useState([]);
  const [userEmployeeOption, setUserEmployeeOption] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [selectedFile, setSelectedFile] = useState({
    file: null,
    filename: "",
  });
  const [pageCompany, setPageCompany] = useState(1);
  const [companyName, setCompanyName] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [sortFirma, setSortFirma] = useState();
  const [selectedCompanyName, setSelectedCompanyName] = useState([]);
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [search, setSearch] = useState();
  const [newpage, setNewPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [userData, setUserData] = useState();
  const [modal, setModal] = useState(false);
  const [isShowClose, setIsShowClose] = useState(false);
  const [uploadImageModal, setUploadImageModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [showUserData, setShowUserData] = useState();
  const [newLoading, setNewLoading] = useState(false);
  const [isAssignSingle, setIsAssignSingle] = useState(false);
  const [currentLead, setCurrentLead] = useState();
  const [assignOption, setAssignOption] = useState();
  const usersData = getUserInfo();
  const [isShowLeadModel, setIsShowLeadModel] = useState(false);
  const [inputValue, setInputValue] = useState({});
  const [error, setError] = useState({});
  const [addUpdateLoader, setAddUpdateLoader] = useState(false);
  const [isEditLead, setIsEditLead] = useState(false);
  const [allCountry, setAllCountry] = useState([]);
  const [selectedUserUids, setSelectedUserUids] = useState([]);

  const assignLeadOption = [
    {
      value: true,
      label: "zugeteilt",
    },
    {
      value: false,
      label: "nicht zugeteilt",
    },
  ];

  const handleSelectRow = (row) => {
    if (selectedRows.length == 0) {
      setSelectedRows([row._id]);
      if (Array.isArray(row?.assignUid)) {
        setSelectedUserUids([row]);
      }
    } else if (selectedRows.includes(row._id)) {
      setSelectedRows(selectedRows.filter((item) => item !== row._id));
      if (Array.isArray(row?.assignUid)) {
        setSelectedUserUids(
          selectedUserUids?.filter((item) => item?._id !== row?._id)
        );
      }
    } else {
      setSelectedRows([...selectedRows, row._id]);
      if (Array.isArray(row?.assignUid)) {
        setSelectedUserUids([...selectedUserUids, row]);
      }
    }
  };

  const handleSelectAllRows = (checked) => {
    if (checked) {
      const allRowIds = getNewsData
        .map((item) => {
          if (!item.apiAdded) {
            return item._id;
          }
        })
        .filter((id) => id !== undefined);
      setSelectedRows(allRowIds);
      setSelectedUserUids(getNewsData);
    } else {
      setSelectedRows([]);
    }
  };
  const handleApply = async (selectedOption, startDate, endDate) => {
    if (!startDate || !endDate) {
      handleChangeCommom("", "startDate");
    } else {
      const timezoneOffset = startDate.getTimezoneOffset() * 60000; // in milliseconds
      startDate = new Date(startDate - timezoneOffset);
      endDate = new Date(endDate - timezoneOffset);
      startDate = startDate.toISOString().split("T")[0];
      endDate = endDate.toISOString().split("T")[0];
      const params = { ...filterData, startDate: startDate, endDate };
      setFilterData(params);
      handleChangeCommom("", "", params);
    }
  };
  const upadteAssign = (row) => {
    setModal(!modal);
    setCurrentLead(row);
    const data = row?.assignUid?.map((item) => {
      return item?._id;
    });
    setSelectedUser(data);
    setShowUserData(row?.assignUid);
    setIsShowClose(row?.status ? false : true);
  };

  const handleSortData = () => {
    setSortFirma(sortFirma == "asc" ? "desc" : "asc");
  };

  const columns = [
    {
      name: (
        <input
          type="checkbox"
          checked={selectedRows?.length === getNewsData?.length}
          onClick={(e) => handleSelectAllRows(e.target.checked)}
        />
      ),
      cell: (row, index) => {
        return (
          <input
            type="checkbox"
            // disabled={row.apiAdded}
            checked={selectedRows.includes(row._id)}
            onChange={() => handleSelectRow(row)}
          />
        );
      },
      width: "60px",
    },
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Vertriebspartner zuweisen</span>,
      minWidth: "250px",
      selector: (row) => (
        <div
          className="profileImage"
          style={{
            display: "flex",
            gap: "10px",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          {row.assignUid?.length ? (
            row.assignUid
              ?.map((item) => item.name)
              .join(", ")
              .slice(0, 20)
          ) : (
            <button
              className="assignButtondesign"
              onClick={() => {
                setModal(!modal);
                setCurrentLead(row);
                setIsShowClose(row?.status ? false : true);
              }}
            >
              Lead zuweisen
            </button>
          )}

          {row.assignUid && (
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => upadteAssign(row)}
              style={{ cursor: "pointer" }}
            >
              <title />

              <g id="Complete">
                <g id="edit">
                  <g>
                    <path
                      d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                      fill="none"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />

                    <polygon
                      fill="none"
                      points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </g>
                </g>
              </g>
            </svg>
          )}
        </div>
      ),
    },

    {
      name: <span>status</span>,
      width: "250px",
      selector: (row) => {
        const statusClass =
          row?.status == "offen" ||
          row?.status == "NICHT ERREICHT" ||
          row?.status == "ZEITLICHE VERZÖGERUNG"
            ? "new-deisgnpppppppppp"
            : row?.status == "STORNO"
            ? "new-deisgn-statusooooooooooo"
            : "newstatusppppppppppp";

        return (
          <div className={statusClass}>{row.status ? row.status : "-"}</div>
        );
      },
    },
    {
      name: <span>Anzahl der Mitarbeiter </span>,
      minWidth: "200px",
      selector: (row) => (
        <div className="profileImage">
          {row.numberOfEmployees ? row?.numberOfEmployees : "-"}
        </div>
      ),
    },
    {
      name: <span>Datum </span>,
      minWidth: "200px",
      selector: (row) => (
        <div className="profileImage">
          {row.createdAt ? (
            <Moment
              format="DD-MM-YYYY , HH:mm:ss"
              tz="CET"
              date={row.createdAt}
            />
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      name: <span>keyword</span>,
      minWidth: "200px",
      selector: (row) => (
        <div className="profileImage">{row.keyword ? row?.keyword : "-"}</div>
      ),
    },
    // {
    //   name: <span>Unique Id </span>,
    //   width: "150px",
    //   selector: (row) => <div className="profileImage">{row.userId ? row.userId : "-"}</div>,
    // },
    // {
    //   name: <span>Benutzername </span>,
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.benutzername ? row.benutzername : "-"}</div>,
    // },
    {
      name: (
        <>
          <span>Firma</span>
          <div onClick={() => handleSortData()} className="sort-button">
            {sortFirma === "desc" ? (
              <div className="up-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="800px"
                  height="800px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 4V20M12 4L8 8M12 4L16 8"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            ) : (
              <div className="down-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="800px"
                  height="800px"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 4V20M12 20L8 16M12 20L16 16"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
        </>
      ),
      width: "250px",
      selector: (row) => (
        <div className="profileImage">{row.firma ? row.firma : "-"}</div>
      ),
    },
    {
      name: "Anrede",
      width: "100px",
      selector: (row) => (
        <div className="profileImage">
          {row.contractions ? row.contractions : "-"}
        </div>
      ),
    },

    {
      name: "Vorname ",
      width: "200px",
      selector: (row) => (
        <div className="profileImage">{row.name ? row.name : "-"}</div>
      ),
    },

    {
      name: " Nachname",
      width: "200px",
      selector: (row) => (
        <div className="profileImage">{row.nachname ? row.nachname : "-"}</div>
      ),
    },

    {
      minWidth: "300px",
      name: " Adresse",
      selector: (row) => (
        <div className="profileImage" style={{ "white-space": "normal" }}>
          {row.strabe ? row.strabe : "-"}
        </div>
      ),
    },

    {
      minWidth: "150px",
      name: "Postleitzahl",
      selector: (row) => (
        <div className="profileImage">{row.pLZ ? row.pLZ : "-"}</div>
      ),
    },

    {
      minWidth: "150px",
      name: "Ort",
      selector: (row) => (
        <div className="profileImage">{row.location ? row.location : "-"}</div>
      ),
    },
    {
      minWidth: "150px",
      name: "Land",
      selector: (row) => (
        <div className="profileImage">{row.country ? row.country : "-"}</div>
      ),
    },

    {
      minWidth: "150px",
      name: "Kontakt",
      selector: (row) => (
        <div className="profileImage">{row.telephon ? row.telephon : "-"} </div>
      ),
    },

    {
      name: "E-mail",
      width: "300px",
      selector: (row) => (
        <div className="profileImage">{row.email ? row.email : "-"}</div>
      ),
    },
    {
      name: "Opening Hours",
      width: "300px",
      selector: (row) => (
        <div className="profileImage">
          {row.openingHours ? row.openingHours : "-"}
        </div>
      ),
    },
    // {
    //   name: "Energieverbrauch",
    //   width: "150px",
    //   selector: (row) => <div className="profileImage">{row.power_consumption ? row.power_consumption : "-"}</div>,
    // },
    // {
    //   name: "Haustyp",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.housetype ? row.housetype : "-"}</div>,
    // },
    // {
    //   name: "Dachtyp",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.satteldach ? row.satteldach : "-"}</div>,
    // },

    // {
    //   name: "Dachbelegung",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.roofFelt ? row.roofFelt : "-"}</div>,
    // },
    // {
    //   name: "Störfaktoren",
    //   minWidth: "250px",

    //   selector: (row) => (
    //     <div className="schornstein" style={{ "white-space": "normal" }}>
    //       {row.schornstein ? row.schornstein.toString() : "-"}
    //     </div>
    //   ),
    // },
    // {
    //   name: "Dachneigung",
    //   minWidth: "250px",

    //   selector: (row) => (
    //     <div className="schornstein" style={{ "white-space": "normal" }}>
    //       {row.dachneigung ? row.dachneigung : "-"}
    //     </div>
    //   ),
    // },
    // {
    //   name: "E-Auto",
    //   width: "200px",
    //   selector: (row) => <div className="profileImage">{row.aktuellkeineAuto ? row.aktuellkeineAuto : "-"}</div>,
    // },

    // {
    //   name: "Wärmepumpe",
    //   minWidth: "300px",
    //   selector: (row) => <div className="profileImage">{row.rooftype ? row.rooftype : "-"}</div>,
    // },

    // {
    //   minWidth: "300px",
    //   name: "Erreichbarkeit",
    //   selector: (row) => (
    //     <div className="profileImage" style={{ "white-space": "normal" }}>
    //       {row.accessibility && row.accessibility !== "undefined" ? row.accessibility : "-"}
    //     </div>
    //   ),
    // },

    {
      minWidth: "300px",
      name: "wichtige Informationen",
      selector: (row) => (
        <div className="profileImage" style={{ "white-space": "normal" }}>
          {row.notizen && row.notizen !== "undefined" ? row.notizen : "-"}
        </div>
      ),
    },

    // {
    //   name: "Unterschrift",
    //   selector: (row) => (
    //     <div onClick={() => newImagefuntion(row.photo)} className="profileFoto">
    //       View
    //     </div>
    //   ),
    // },

    // {
    //   minWidth: "250px",
    //   name: "Sales Patners",
    //   selector: (row) => (
    //     <div className="profileImage" style={{ "white-space": "normal" }}>
    //       {row?.patners?.length > 0 ? row?.patners?.map((item) => item.name).join(",") : "-"}
    //     </div>
    //   ),
    // },

    {
      minWidth: "150px",
      name: "Aktion",
      selector: (row) => (
        <div className="actionColumn">
          <Button
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => {
              handleEditLead(row);
            }}
          >
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              style={{ cursor: "pointer" }}
            >
              <title />

              <g id="Complete">
                <g id="edit">
                  <g>
                    <path
                      d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                      fill="none"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />

                    <polygon
                      fill="none"
                      points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                      stroke="#000000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </Button>

          <Button
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => {
              handleConfirmDelete(row);
            }}
          >
            <Trash className="font-medium-2" />
          </Button>
        </div>
      ),
    },
  ];
  const handleDeleteNewsInfo = async (row) => {
    setLoading(true);
    let response = false;
    await ApiDelete(`straper/deleteVattenfall?id=${row?._id}`)
      .then((res) => {
        setLoading(false);
        handleChangeCommom("", "", filterData);
        response = true;
      })
      .catch((err) => {
        setLoading(false);
      });
    return response;
  };

  const handleConfirmDelete = (row) => {
    return Swal.fire({
      title: "Bist du sicher?",
      text: "Sind Sie sicher, dass Sie den Lead löschen möchten?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ja, löschen",
      cancelButtonText: "Abbrechen",
      customClass: {
        confirmButton: "btn btn-primary mr-10",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async function (result) {
      if (result.value) {
        const res = await handleDeleteNewsInfo(row);
        if (res) {
          Swal.fire({
            icon: "success",
            title: "Gelöscht!",
            text: "Die Lead wurde gelöscht.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          Swal.fire({
            title: "Abgesagt",
            text: "Löschung abgebrochen!!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Abgesagt",
          text: "Löschung abgebrochen!!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        Swal.fire({
          title: "Abgesagt",
          text: "Löschung abgebrochen!!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  };

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "200px",
      marginLeft: "20px",
      fontSize: "12px",
      border: state.isFocused ? "2px solid #73AA85 !important" : "",
      boxShadow: "1px solid #73AA85 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      color: state.isSelected ? "white" : "black",
      backgroundColor: state.isSelected ? "#73AA85" : "white",
      "&:hover": {
        backgroundColor: "#73AA85",
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "200px",
      marginLeft: "20px",
      zIndex: "999",
    }),
  };
  const ProjectStyle = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "150px",
      fontSize: "12px",
      marginLeft: "30px",
      border: state.isFocused ? "2px solid #73AA85 !important" : "",
      boxShadow: "1px solid #73AA85 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      color: state.isSelected ? "white" : "black", // Change selected color here
      backgroundColor: state.isSelected ? "#73AA85" : "white",
      "&:hover": {
        backgroundColor: "#73AA85",
      },
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "150px",
      marginLeft: "30px",
      zIndex: "999",
    }),
  };

  useEffect(() => {
    handleChangeCommom("", "", filterData);
  }, [
    debouncedSearchValue,
    page,
    countPerPage,
    assignOption,
    selectedCompanyName,
    sortFirma,
    selectedEmployee,
  ]);

  useEffect(() => {
    const handleGetSalesPatner = async () => {
      try {
        const response = await ApiGet(`user/get`);
        const data = response?.data?.payload?.data;
        if (data && Array.isArray(data)) {
          const optionData = data.map((item) => ({
            value: item?._id,
            label: item?.name,
          }));

          setUserName(optionData);
        }
      } catch (error) {
        toast.error("Vertriebspartner konnten nicht abgerufen werden..");
      }
    };
    const handleGetNumberEmployee = async () => {
      try {
        const response = await ApiGet(`vattenfall/employees-range`);
        const data = response?.data?.payload;
        if (data && Array.isArray(data)) {
          const optionData = data.map((item) => ({
            value: item,
            label: item,
          }));

          setUserEmployeeOption(optionData);
        }
      } catch (error) {
        toast.error("Vertriebspartner konnten nicht abgerufen werden..");
      }
    };

    const handleGetProject = async () => {
      await ApiGet(`project/get`)
        .then((response) => {
          const data = response?.data?.payload.data;
          const optionData = data?.map((item) => ({
            value: item._id,
            label: item.projectname,
          }));
          setProjectOptions(optionData);
        })
        .catch((error) => {
          toast.error(error);
        });
    };

    handleGetNumberEmployee();
    handleGetSalesPatner();
    handleGetProject();
    handleGetAllCompany(pageCompany);
  }, []);

  const handleGetAllCompany = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await ApiGet(
        `vattenfall/uniqueFirma?page=${pageNumber}&limit=10`
      );
      const data = response?.data?.payload;

      if (data && Array.isArray(data)) {
        const optionData = data.map((item) => ({
          value: item?.firma,
          label: item?.firma,
        }));

        setCompanyName((prevOptions) => [...prevOptions, ...optionData]);
        if (data.length === 0) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCommom = async (e, key, filter) => {
    let updatedFilter = { ...filterData };

    if (!e && key) {
      if (key == "userId") {
        setSelectedUserName("");
      } else if (key == "projectName") {
        setSelectedProject("");
      }

      if (key === "startDate" || key === "endDate") {
        updatedFilter.startDate = "";
        updatedFilter.endDate = "";
      } else {
        updatedFilter[key] = "";
      }
    } else {
      if (key == "userId") {
        updatedFilter = {
          ...filterData,
          [`${key}[]`]: e.map((item) => item.value),
        };
      } else if (key == "keyword") {
        updatedFilter = {
          ...filterData,
          [`${key}`]: e.map((item) => item.value),
        };
      } else if (key == "country") {
        updatedFilter = {
          ...filterData,
          [`${key}`]: e.map((item) => item.value),
        };
      } else {
        updatedFilter = key ? { ...filterData, [key]: e.label } : filter;
      }
    }

    setLoading(true);
    let ddd = "";
    for (const [key, value] of Object.entries(updatedFilter)) {
      if (Array?.isArray(value)) {
        for (const v of value) {
          ddd += `${key}=${v}&`;
        }
      } else if (value) {
        const data = encodeURIComponent(value);
        ddd += `${key}=${data}&`;
      }
    }

    let body = {
      firma:
        selectedCompanyName?.length > 0
          ? selectedCompanyName
              .map((item) => item.value.replace(/"/g, "")) // Remove quotes from each value
              .join(",")
          : "",
    };
    try {
      const response = await ApiPost(
        `straper/getVattenfall?${ddd}&limit=${countPerPage}&page=${page}${
          selectedEmployee?.value
            ? `&numberOfEmployees=${selectedEmployee?.value}`
            : ""
        }${debouncedSearchValue ? `&search=${searchValue}` : ""}${
          assignOption ? `&isAssign=${assignOption?.value}` : ""
        }  ${sortFirma ? `&sortFirma=${sortFirma}` : ""}`,
        body
      );
      const data = response?.data?.payload.data;
      setCount(response?.data?.payload.count);
      if (key == "userId") {
        setSelectedUserName(e);
      } else if (key == "projectName") {
        setSelectedProject(e);
      } else if (key == "keyword") {
        setSelectedKeyword(e);
      } else if (key == "country") {
        setSelectedCountry(e);
      }
      setGetNewsData(data);
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }

    setFilterData(updatedFilter);
  };

  const customNoDataComponent = () => (
    <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>
      Aktuell sind keine Daten vorhanden.
    </div>
  );

  const getUserData = async () => {
    await ApiGet(
      `user/get?page=${newpage}&limit=${limit}${
        search ? `&search=${search}` : ""
      }`
    )
      .then((response) => {
        const data = response?.data?.payload.data;
        setCountForModel(response?.data?.payload.count / 10);
        setUserData(response?.data?.payload.data);

        // const activeData = data.filter((jobData) => {
        //   return jobData.roleId._id == "65fc2112e8fe93f708e798c3";
        // });
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  useEffect(() => {
    getUserData();
  }, [newpage, limit, search]);

  const handlePage = () => {
    setNewPage((prev) => prev + 1);
  };
  const handleback = () => {
    setNewPage((prev) => prev - 1);
  };

  const handleCheckBox = (item, id) => {
    setSelectedUser((prevUserPostal) => {
      if (!prevUserPostal || prevUserPostal.length === 0) {
        return [id];
      } else if (prevUserPostal.includes(id)) {
        return prevUserPostal.filter((item) => item !== id);
      } else {
        return [...prevUserPostal, id];
      }
    });
    setShowUserData((prevPostal) => {
      if (!prevPostal || prevPostal.length === 0) {
        return [item];
      } else if (prevPostal.find((postalItem) => postalItem._id === id)) {
        return prevPostal.filter((postalItem) => postalItem._id !== id);
      } else {
        return [...prevPostal, item];
      }
    });
  };
  const removeItem = (newitem) => {
    setShowUserData((prevData) => {
      if (prevData.find((postalItem) => postalItem._id === newitem?._id)) {
        return prevData.filter((postalItem) => postalItem._id !== newitem?._id);
      }
    });

    setSelectedUser((prevUserPostal) => {
      if (prevUserPostal.includes(newitem?._id)) {
        return prevUserPostal.filter((item) => item !== newitem?._id);
      }
    });
  };

  const assignLeadUser = async () => {
    setNewLoading(true);
    if (isAssignSingle) {
      try {
        const body = {
          assignUid: selectedUser?.length > 0 ? selectedUser : [],
        };
        const ids = selectedRows.join(",");
        let resp = await ApiPut(`vattenfall/assignLead?id=${ids}`, body);
        toast.success("Zugewiesen");
        setModal(!modal);
        setSelectedUser([]);
        setSelectedRows([]);
        setIsAssignSingle(false);
        setShowUserData("");
        handleChangeCommom("", "", filterData);
      } catch (error) {
        console.log(error);
        toast.error("somthing went wrong");
      } finally {
        setNewLoading(false);
      }
    } else {
      try {
        const body = {
          assignUid: selectedUser?.length > 0 ? selectedUser : [],
        };
        let resp = await ApiPut(
          `vattenfall/assignLead?id=${currentLead?._id}`,
          body
        );
        toast.success("Zugewiesen");
        setModal(!modal);
        setSelectedUser([]);
        setShowUserData("");
        handleChangeCommom("", "", filterData);
      } catch (error) {
        console.log(error);
        toast.error("somthing went wrong");
      } finally {
        setNewLoading(false);
      }
    }
  };

  const handleChangeAssign = (data) => {
    setAssignOption(data);
  };

  const handleAddNewsClose = () => {
    setIsShowLeadModel(false);
    setInputValue({});
    setError({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
    setError({ ...error, [name]: "" });
  };

  const handleEditLead = (row) => {
    setIsEditLead(true);
    setIsShowLeadModel(true);
    setInputValue({
      decisionMakerReached: row?.decisionMakerReached,
      numberOfEmployees: row?.numberOfEmployees,
      website: row?.website,
      anrede: row?.contractions,
      vorname: row?.name,
      nachname: row?.nachname,
      comment: row?.comment,
      firma: row?.firma,
      adresse: row?.strabe,
      postleitzahl: row?.pLZ,
      ort: row?.location,
      kontakt: row?.telephon,
      eMail: row?.email,
      importantInfo: row?.notizen,
      openingHours: row?.openingHours,
      id: row?._id,
    });
  };

  const handleAddUser = () => {
    const isValid = ValidateForm(inputValue, setError);
    if (isValid) {
      setAddUpdateLoader(true);

      let body = {
        name: inputValue?.vorname ? inputValue?.vorname : "",
        nachname: inputValue?.nachname ? inputValue?.nachname : "",
        comment: inputValue?.comment ? inputValue?.comment : "",
        firma: inputValue?.firma ? inputValue?.firma : "",
        strabe: inputValue?.adresse ? inputValue?.adresse : "",
        pLZ: inputValue?.postleitzahl ? inputValue?.postleitzahl : "",
        location: inputValue?.ort ? inputValue?.ort : "",
        telephon: inputValue?.kontakt ? inputValue?.kontakt : "",
        email: inputValue?.eMail ? inputValue?.eMail : "",
        notizen: inputValue?.importantInfo ? inputValue?.importantInfo : "",
        contractions: inputValue?.anrede ? inputValue?.anrede : "",
        ...(inputValue?.website && {
          website: inputValue?.website ? inputValue?.website : "",
        }),
        ...(inputValue?.numberOfEmployees && {
          numberOfEmployees: inputValue?.numberOfEmployees
            ? inputValue?.numberOfEmployees
            : "",
        }),
        ...(inputValue?.decisionMakerReached && {
          decisionMakerReached: inputValue?.decisionMakerReached
            ? inputValue?.decisionMakerReached
            : "",
        }),
        ...(inputValue?.openingHours && {
          openingHours: inputValue?.openingHours
            ? inputValue?.openingHours
            : "",
        }),
        benutzername: "admin",
        benutzerId: usersData?._id,
        locationCoordinates: JSON.stringify(inputValue?.locationCoordinates),

        // status: "offen",
      };

      ApiPost(`straper/vattenfall`, body)
        .then((res) => {
          toast.success("Lead erfolgreich hinzugefügt");
          handleAddNewsClose();
          handleChangeCommom("", "", filterData);
          setAddUpdateLoader(false);
          setInputValue({});
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setAddUpdateLoader(false);
          handleAddNewsClose();
          setInputValue({});
        });
    }
  };
  const handleUpdateLead = () => {
    const isValid = ValidateForm(inputValue, setError);
    if (isValid) {
      setAddUpdateLoader(true);
      let body = {
        name: inputValue?.vorname ? inputValue?.vorname : "",
        nachname: inputValue?.nachname ? inputValue?.nachname : "",
        firma: inputValue?.firma ? inputValue?.firma : "",
        comment: inputValue?.comment ? inputValue?.comment : "",
        strabe: inputValue?.adresse ? inputValue?.adresse : "",
        pLZ: inputValue?.postleitzahl ? inputValue?.postleitzahl : "",
        location: inputValue?.ort ? inputValue?.ort : "",
        telephon: inputValue?.kontakt ? inputValue?.kontakt : "",
        email: inputValue?.eMail ? inputValue?.eMail : "",
        ...(inputValue?.website && {
          website: inputValue?.website ? inputValue?.website : "",
        }),
        ...(inputValue?.numberOfEmployees && {
          numberOfEmployees: inputValue?.numberOfEmployees
            ? inputValue?.numberOfEmployees
            : "",
        }),
        ...(inputValue?.decisionMakerReached && {
          decisionMakerReached: inputValue?.decisionMakerReached
            ? inputValue?.decisionMakerReached
            : "",
        }),
        ...(inputValue?.openingHours && {
          openingHours: inputValue?.openingHours
            ? inputValue?.openingHours
            : "",
        }),
        notizen: inputValue?.importantInfo ? inputValue?.importantInfo : "",
        contractions: inputValue?.anrede ? inputValue?.anrede : "",
        benutzername: "admin",
        benutzerId: usersData?._id,
        // status: "offen",
      };

      ApiPut(`vattenfall/updateLeadVatten?id=${inputValue?.id}`, body)
        .then((res) => {
          toast.success("Lead erfolgreich aktualisiert");
          handleAddNewsClose();
          handleChangeCommom("", "", filterData);
          setAddUpdateLoader(false);
          setIsEditLead(false);
          setInputValue({});
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setAddUpdateLoader(false);
          setIsEditLead(false);
          handleAddNewsClose();
          setInputValue({});
        });
    }
  };

  const handleSelectEmployee = (e) => {
    if (!e) {
      setSelectedEmployee("");
    } else {
      setSelectedEmployee(e);
    }
  };

  const handleSheetUploadButton = () => {
    setUploadImageModal(true);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      if (
        fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setSelectedFile({
          file: file,
          filename: file?.name,
        }); // Store the selected file in state if it's an .xlsx file
      } else {
        toast.error("Bitte laden Sie eine gültige XLSX-Datei hoch");
        event.target.value = null; // Clear the file input if invalid file type
      }
    }
  };

  const handleUploadSheet = async () => {
    if (!selectedFile?.file)
      return toast.error(`Bitte wählen Sie eine Datei zum Hochladen aus`);
    setNewLoading(true);
    try {
      let formData = new FormData();
      formData.append("file", selectedFile?.file ? selectedFile?.file : null);
      let resp = await ApiPost(`vattenfall/uploadExcel`, formData);
      toast.success(resp?.data?.message);
      setUploadImageModal(!uploadImageModal);
      setNewLoading(false);
      setIsShowClose(false);
      setSelectedFile(null);
      handleChangeCommom("", "", filterData);
    } catch (error) {
      setIsShowClose(false);
      setNewLoading(false);
      toast.error("Invalid file format", error);
    } finally {
      setIsShowClose(false);
      setNewLoading(false);
    }
  };

  const getAllKeyWords = async () => {
    try {
      const response = await ApiGet("vattenfall/getKeywordList");
      const data = response?.data?.payload?.keywords?.map((item) => {
        const data = {
          value: item,
          label: item,
        };
        return data;
      });
      setKeywords(data);
    } catch (error) {}
  };

  const getAllCountry = async () => {
    try {
      const response = await ApiGet("vattenfall/getCountryList");
      const data = response?.data?.payload?.country?.map((item) => {
        const data = {
          value: item,
          label: item,
        };
        return data;
      });
      setAllCountry(data);
    } catch (error) {}
  };

  useEffect(() => {
    getAllKeyWords();
    getAllCountry();
  }, []);

  const handledownload = () => {
    let newdata = selectedUserUids?.map((item) => ({
      "Created date": moment(item?.createdAt).format("YYYY/MM/DD"),
      Name: item?.name ?? "-",
      Nachname: item?.nachname ?? "-",
      Status: item?.status ?? "-",
      Telephon: item?.telephon ?? "-",
      "E-mail": item?.email ?? "-",
      Firma: item?.firma ?? "-",
      Adresse: item?.strabe ?? "-",
      Ort: item?.location ?? "-",
      Postleitzahl: item?.pLZ ?? "-",
      LeadNotes: item?.leadNotes ?? "-",
      Country: item?.country ?? "-",
      Website: item?.website ?? "-",
      Keyword: item?.keyword ?? "-",
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(newdata);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "LeadData.xlsx");
    // setSelectedUserUids([]);
    // setSelectedRows([]);
  };

  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className=" mb-4 pr-3 " style={{ flexDirection: "column" }}>
            <div className="px-3 Vattenfall-mobile-title vattenfall-title">
              <div className="d-flex align-items-center justify-content-between pb-2">
                <h2 className="pt-2 mr-5">Leads</h2>
                <div className="d-flex align-items-center gap-3">
                  <div className="header-items cus-medium-button-style button-height cusbutton-moblie mr-3">
                    <button
                      onClick={() => {
                        setIsShowLeadModel(true);
                        setIsEditLead(false);
                      }}
                      className="btn btn addbutton"
                      style={{ width: "100%" }}
                    >
                      Leads hinzufügen
                    </button>
                  </div>

                  <div
                    style={{
                      whiteSpace: "nowrap",
                      display: "flex",
                      gap: "10px",
                    }}
                    className="header-items add-buttons-main"
                  >
                    <button
                      className="btn btn addbutton"
                      onClick={() => handleSheetUploadButton()}
                    >
                      <span style={{ paddingRight: "6px" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="#ffffff"
                            d="M288 109.3L288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-242.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352l128 0c0 35.3 28.7 64 64 64s64-28.7 64-64l128 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                          />
                        </svg>
                      </span>
                      Blatt hochladen
                    </button>
                    {selectedUserUids?.length > 0 && (
                      <button
                        className="btn btn addbutton"
                        onClick={() => handledownload()}
                      >
                        Download
                      </button>
                    )}
                    {selectedRows?.length > 0 && (
                      <button
                        className="btn btn addbutton"
                        onClick={() => {
                          setModal(!modal);
                          setIsAssignSingle(true);
                        }}
                      >
                        Lead zuweisen
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="row-mobile-collg8main vattenfall-mobile-header-rs header-main-inputs-layout">
                <div className="date-filter header-items">
                  <DateFilter
                    onApply={handleApply}
                    className="Datefilter-flx-mobile-main"
                  />
                </div>

                <div className="header-items">
                  <div className="project-Dropdown project-Dropdown-sc">
                    <Select
                      className="Select-main"
                      // menuIsOpen={true}
                      value={assignOption}
                      name="isAssign"
                      onChange={(e) => handleChangeAssign(e, "isAssign")}
                      options={assignLeadOption}
                      styles={ProjectStyle}
                      defaultValue={assignOption}
                      placeholder="zugeteilt"
                      isClearable={true}
                    />
                  </div>
                </div>

                <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="Select-main"
                      // menuIsOpen={true}
                      value={selectedProject}
                      name="projectName"
                      onChange={(e) => handleChangeCommom(e, "projectName")}
                      options={projectOptions}
                      styles={ProjectStyle}
                      defaultValue={selectedProject}
                      placeholder="Projekt "
                      isClearable={true}
                    />
                  </div>
                </div>

                <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="dropdown-align "
                      value={selectedUserName}
                      name="userName"
                      onChange={(e) => {
                        handleChangeCommom(e, "userId");
                      }}
                      placeholder="Vertriebspartner"
                      options={userName}
                      maxHeight={"40px"}
                      defaultValue={selectedUserName}
                      isClearable={true}
                      isMulti
                      styles={customStyle}
                    />
                  </div>
                </div>
                <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="dropdown-align "
                      value={selectedKeyword}
                      name="keyword"
                      onChange={(e) => {
                        handleChangeCommom(e, "keyword");
                      }}
                      placeholder="keyword"
                      options={keywords}
                      isMulti
                      maxHeight={"40px"}
                      isClearable={true}
                      styles={customStyle}
                    />
                    {/* <Select
                      className="dropdown-align "
                      value={selectedEmployee}
                      name="selectedEmployee"
                      onChange={(e) => {
                        handleChangeCommom(e, "numberOfEmployees");
                      }}
                      placeholder="Anzahl der Mitarbeiter"
                      options={userEmployeeOption}
                      maxHeight={"40px"}
                      defaultValue={selectedEmployee}
                      isClearable={true}
                      styles={customStyle}
                    /> */}
                  </div>
                </div>
                <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="dropdown-align "
                      value={selectedCountry}
                      name="country"
                      onChange={(e) => {
                        handleChangeCommom(e, "country");
                      }}
                      placeholder="Land"
                      options={allCountry}
                      isMulti
                      maxHeight={"40px"}
                      isClearable={true}
                      styles={customStyle}
                    />
                    {/* <Select
                      className="dropdown-align "
                      value={selectedEmployee}
                      name="selectedEmployee"
                      onChange={(e) => {
                        handleChangeCommom(e, "numberOfEmployees");
                      }}
                      placeholder="Anzahl der Mitarbeiter"
                      options={userEmployeeOption}
                      maxHeight={"40px"}
                      defaultValue={selectedEmployee}
                      isClearable={true}
                      styles={customStyle}
                    /> */}
                  </div>
                </div>
                <div className="header-items">
                  <div className="project-Dropdown">
                    <Select
                      className="dropdown-align "
                      value={selectedEmployee}
                      name="numberOfEmployees"
                      onChange={(e) => {
                        handleSelectEmployee(e);
                      }}
                      placeholder="Firmennamen"
                      options={userEmployeeOption}
                      maxHeight={"40px"}
                      defaultValue={selectedEmployee}
                      isClearable={true}
                      styles={customStyle}
                    />
                    {/* <Select
                      className="dropdown-align "
                      value={selectedEmployee}
                      name="selectedEmployee"
                      onChange={(e) => {
                        handleChangeCommom(e, "numberOfEmployees");
                      }}
                      placeholder="Anzahl der Mitarbeiter"
                      options={userEmployeeOption}
                      maxHeight={"40px"}
                      defaultValue={selectedEmployee}
                      isClearable={true}
                      styles={customStyle}
                    /> */}
                  </div>
                </div>

                <div className="header-items">
                  <input
                    type="search"
                    className={`form-control form-control-lg form-control-solid `}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      setLoading(true);
                    }}
                    name="search"
                    value={searchValue}
                    placeholder="Suche"
                  />
                </div>
              </div>
            </div>

            {/* <div className="col-lg-8">
              <div style={{ display: "flex", justifyContent: "end", gap: "20px", padding: "5px 10px 0 0", flexWrap: "wrap" }}>
                <button className="btn btn addbutton" onClick={() => handleSheetUploadButton()}>
                  <span style={{ paddingRight: "6px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 512 512">
                      <path
                        fill="#ffffff"
                        d="M288 109.3L288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-242.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352l128 0c0 35.3 28.7 64 64 64s64-28.7 64-64l128 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                      />
                    </svg>
                  </span>
                  Blatt hochladen
                </button>
                {selectedRows?.length > 0 && (
                  <div>
                    <button
                      className="btn btn addbutton"
                      onClick={() => {
                        setModal(!modal);
                        setIsAssignSingle(true);
                      }}
                    >
                      Lead zuweisen
                    </button>
                  </div>
                )}
              </div>
            </div> */}
          </div>
          <DataTable
            data={getNewsData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>
      </div>

      <Modal
        show={isShowLeadModel}
        onHide={handleAddNewsClose}
        className="d-flex justify-content-center align-items-center"
      >
        <AddLeadDetails
          inputValue={inputValue}
          setInputValue={setInputValue}
          handleOnClose={handleAddNewsClose}
          formType={isEditLead ? "update" : "add"}
          handleChange={handleChange}
          handleAddNews={isEditLead ? handleUpdateLead : handleAddUser}
          loading={addUpdateLoader}
          errors={error}
          setError={setError}
        />
      </Modal>

      {close && (
        <div className="new__imagemodel">
          <div className="body_model"></div>
          <div className="new-white-box">
            <div className="header_close">
              <i
                onClick={() => {
                  setclose(!close);
                  setimage("");
                }}
                className="fas fa-window-close modalClose"
              ></i>
            </div>
            <div className="image_body">
              {fileType == "svg" ||
              fileType == "png" ||
              fileType == "jpg" ||
              fileType == "jpeg" ? (
                <>
                  <img className="modal-image" src={image} />
                </>
              ) : fileType === "pdf" ? (
                <>
                  <object
                    data={image}
                    type="application/pdf"
                    width="420px"
                    height="650px"
                  ></object>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}

      {modal && (
        <div className="edit-drop-down-main">
          <div className="edit-drop-down-content-main">
            <div className="edit-drop-down-content">
              <div className="header-text">Vertriebspartner</div>
              <div style={{ cursor: "pointer" }}>
                <i
                  className="fa-sharp fa-solid fa-xmark"
                  onClick={() => {
                    setModal(!modal);
                    setSearch("");
                    setSelectedUser([]);
                    setShowUserData();
                    setIsAssignSingle(false);
                    setIsShowClose(false);
                  }}
                ></i>
              </div>
            </div>

            <div className="edit-drop-down-body">
              <div className="input-search">
                <input
                  type="text"
                  placeholder="Suche"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </div>

              <div className="postalcode-model-design">
                <div className="modalPlzAlign">
                  {Array.isArray(showUserData) &&
                    showUserData.length > 0 &&
                    showUserData?.map((item) => {
                      return (
                        <p>
                          {item?.name}{" "}
                          {
                            <i
                              class="fa-sharp fa-solid fa-xmark"
                              onClick={() => removeItem(item)}
                              style={{ color: "white" }}
                            />
                          }
                        </p>
                      );
                    })}
                </div>
              </div>

              {Array.isArray(userData) && userData.length > 0 ? (
                userData.map((item) => (
                  <div className="checckbox-alignmnent" key={item._id}>
                    <input
                      type="checkbox"
                      checked={selectedUser?.includes(item._id)}
                      onChange={() => handleCheckBox(item, item._id)}
                    />
                    <p>{item?.name}</p>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "40px",
                  }}
                >
                  <p>Aktuell sind keine Daten vorhanden.</p>{" "}
                </div>
              )}
            </div>

            <div className="edit-drop-down-pagination">
              <button onClick={() => assignLeadUser()}>
                {newLoading ? (
                  <TailSpin
                    color="#ffffff"
                    height={22}
                    width={22}
                    ariaLabel="loading"
                  />
                ) : (
                  "Speichern"
                )}
              </button>

              <div className="butoon-alignment">
                {newpage !== 1 && (
                  <div className="previus" onClick={handleback}>
                    <i className="fa-solid fa-angle-left"></i>
                  </div>
                )}

                {newpage < Math.ceil(countForModel) && (
                  <div className="next" onClick={handlePage}>
                    <i className="fa-solid fa-angle-right"></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {uploadImageModal && (
        <div className="edit-drop-down-main edit-drop-down-main-upload">
          <div className="edit-drop-down-content-main">
            <div className="edit-drop-down-content">
              <div className="header-text">Blatt hochladen</div>
              <div style={{ cursor: "pointer" }}>
                <i
                  className="fa-sharp fa-solid fa-xmark"
                  onClick={() => {
                    setUploadImageModal(!uploadImageModal);
                  }}
                ></i>
              </div>
            </div>

            <div className="upload-file-div-main">
              <div className="preview-div">
                {selectedFile?.file ? (
                  <div className="file-div">
                    <img src={excelIcon} alt="excelIcon" />
                  </div>
                ) : (
                  <span style={{ fontSize: "14px", fontWeight: 600 }}>
                    Kein Blatt hochgeladen
                  </span>
                )}
                {selectedFile?.file && (
                  <div className="file-name">
                    <span>{selectedFile?.filename}</span>
                  </div>
                )}
              </div>
              <div className="upload-file-div">
                <input
                  type="file"
                  name="uploadedSheet"
                  onChange={handleFileChange}
                />
                <div className="upload-div">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="22"
                    id="upload"
                  >
                    <g
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    >
                      <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                    </g>
                  </svg>
                  <p>Blatt hochladen</p>
                </div>
              </div>
            </div>

            <div className="edit-drop-down-pagination">
              <button onClick={() => handleUploadSheet()}>
                {newLoading ? (
                  <TailSpin
                    color="#ffffff"
                    height={22}
                    width={22}
                    ariaLabel="loading"
                  />
                ) : (
                  "Speichern"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
